const Role = require('../entities/role');

const PagedList = require('../entities/paged-list');

const fields = ['id', 'sid', 'name', 'desc', 'type'];

class RolesRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  search()
  /*: (Promise<PagedList<Role>>)*/
  {
    const req = new this.client.Request(`/roles/search`, {}, fields);

    req.parse = json => new Role(json.id, json.sid, json.name, json.desc, json.type);

    return this.client.get(req).then(roles => new PagedList(roles.items, roles.page));
  }

  list({
    /*: { type: string }*/

    type
  } = {})
  /*: (Promise<PagedList<Role>>)*/
  {
    const req = new this.client.Request(`/roles`, {
      offset: 0,
      limit: 50
    }, fields);

    req.parse = json => new Role(json.id, json.sid, json.name, json.desc, json.type);

    return this.client.get(req).then(roles => {
      if (!type) return roles;
      return new PagedList(roles.items.filter(role => role.type === type), roles.page);
    });
  }

  find({
    /*: { sid: string }*/

    sid
  }) {
    return this.list().then(({
      items
    }) => items.find(item => item.sid === sid));
  }

}

module.exports = RolesRepo;